module.exports = __webpack_public_path__ + "img/astral_2.7ac942c6.svg";